// NPM Imports
import React from "react";
import { connect } from "react-redux";
import moment from "moment";
// import { useDispatch, useSelector } from "react-redux";
// import { Loader } from "../../../revvComponents";

// Components Imports
import MetaFieldItem from "./MetaFieldItem";

// Constant imports
import { emptyImage } from "../../../constants/images";

// Actions Imports
import {
  updateMetaFieldAction,
  updateTemplateMetaFieldInDocAction,
} from "../../../actions/MetaFieldActions";
// Internal Imports

// Destructuring

// Declarations

const MetaFieldItems = ({
  metaFieldItems,
  templateObjectId,
  documentObjectId,
  updateMetaField,
  category,
  fillMetaField,
  handleDeleteMetaField,
}) => {
  const handleUpdateMetaField = (
    metaFieldItem,
    updatedMetaFieldName,
    updatedMetaFieldValue,
  ) => {
    const docMode = templateObjectId ? "templates" : "documents";
    const objectId = templateObjectId || documentObjectId;
    const metaGroupId = category ? category.id : "";
    metaFieldItem.value = updatedMetaFieldValue;
    if (docMode === "documents") {
      if (category.level === "TEMPLATE") {
        const updatedObject = {
          values: {
            [updatedMetaFieldName]: updatedMetaFieldValue,
          },
        };
        fillMetaField(
          docMode,
          objectId,
          metaGroupId,
          updatedMetaFieldName,
          updatedObject,
        );
      } else {
        const updatedObject = {
          fields: {
            [updatedMetaFieldName]: {
              ...metaFieldItem,
            },
          },
        };
        updateMetaField(docMode, objectId, updatedObject);
      }
    }
    if (docMode === "templates") {
      const updatedObject = {
        fields: {
          [updatedMetaFieldName]: {
            ...metaFieldItem,
          },
        },
      };
      updateMetaField(docMode, objectId, updatedObject);
    }
  };

  const calculateOptions = metaFieldItem => {
    const multiSelectOptions = [];
    const metaField = metaFieldItems[metaFieldItem];
    if (metaField && metaField.field_meta && metaField.field_meta.options) {
      const {
        field_meta: { options },
      } = metaField;
      options.forEach(option => {
        multiSelectOptions.push({ id: option, label: option, value: option });
      });
    }
    return multiSelectOptions;
  };

  const calculatedDefaultValues = metaFieldItem => {
    let defaultValue;
    const metaField = metaFieldItems[metaFieldItem];

    switch (metaField.field_type) {
      case "TEXT":
      case "NUMBER": {
        defaultValue = metaField.value ? metaField.value : "";
        return defaultValue;
      }
      case "DATE": {
        defaultValue = metaField.value
          ? moment(metaField.value).format("DD-MM-YYYY")
          : "";
        return defaultValue;
      }
      case "SINGLE_SELECT": {
        defaultValue = [];
        if (metaField && metaField.value) {
          const { value: singleSelectDefVal } = metaField;
          defaultValue.push({
            id: singleSelectDefVal,
            label: singleSelectDefVal,
            value: singleSelectDefVal,
          });
        }
        return defaultValue;
      }
      case "MULTI_SELECT": {
        defaultValue = [];
        if (
          metaField &&
          metaField.value &&
          Array.isArray(metaField.value) &&
          metaField.value.length > 0
        ) {
          const { value } = metaField;
          value.forEach(option => {
            defaultValue.push({ label: option, value: option });
          });
        }
        return defaultValue;
      }
      default: {
        return metaField.value;
      }
    }
  };

  const checkDeletePossiblity = () => {
    if (documentObjectId && category.level === "TEMPLATE") return false;
    return true;
  };

  return (
    <div className="metafieldview-container">
      {/* {currentView === "local_mf" && (
        <MetaFieldViewHeader metaFieldsCount={metaFieldsCount} />
      )} */}
      {metaFieldItems && Object.keys(metaFieldItems).length > 0 ? (
        Object.keys(metaFieldItems).map(metaFieldItem => (
          <MetaFieldItem
            metaFieldItem={metaFieldItems[metaFieldItem]}
            metaFieldItemName={metaFieldItem}
            handleDeleteMetaField={() => handleDeleteMetaField(metaFieldItem)}
            handleUpdateMetaField={handleUpdateMetaField}
            availableOptions={calculateOptions(metaFieldItem)}
            defaultValues={calculatedDefaultValues(metaFieldItem)}
            canBeDeleted={checkDeletePossiblity()}
          />
        ))
      ) : (
        <>
          <img
            src={emptyImage}
            alt="empty-metatags"
            className="metafield-info-img"
          />
          <div className="metafield-info-note">
            Nothing added here yet! Create new metafield above
          </div>
        </>
      )}
      {/* Below we need to add listing component */}
    </div>
  );
};

const mapStateToProps = state => {
  const {
    customDynamicFieldData,
    template: { object_id: templateObjectId },
  } = state.TemplateStore;
  const {
    document: { objectId: documentObjectId },
  } = state.DocumentStore;
  return {
    customDynamicFieldData,
    templateObjectId,
    documentObjectId,
  };
};

const mapDispatchToProps = {
  updateMetaField: updateMetaFieldAction,
  fillMetaField: updateTemplateMetaFieldInDocAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(MetaFieldItems);
